export function runtimeConfig() {
  const value = globalThis.window?.__JARVIS_CONFIG__ ?? {};
  return {
    supabaseUrl: String(value.supabaseUrl ?? "").trim(),
    supabaseAnonKey: String(value.supabaseAnonKey ?? "").trim(),
    apiBaseUrl: String(value.apiBaseUrl ?? "/api").replace(/\/$/, ""),
  };
}
